import { getBundle } from '@nrk/nrkno-snowplow'
import { EntitySchema } from '@nrk/snowplow-web'
import { SelfDescribingJson } from '@snowplow/tracker-core'

const APP_ID = 'no.nrk.dh'
export const Schemas = {
  StepEvent: 'iglu:no.nrk.dh/step-event/jsonschema/1-0-0',
  ViewportEvent: 'iglu:no.nrk.dh/viewport-event/jsonschema/1-0-0',
}

export type StepEvent = {
  current: number
  total: number
}

export type ViewportEvent = {
  kind: 'entry' | 'exit'
}

function resolveOrTimeout(promise: Promise<any>, wait: number): Promise<boolean> {
  return Promise.race([
    promise.then(() => true),
    new Promise<boolean>((resolve) => {
      setTimeout(() => {
        resolve(false)
      }, wait)
    }),
  ])
}

export function setupTracker(
  trackerId: `dh-${string}`,
  { host, selfId }: { host: `https://${string}`; selfId?: string },
) {
  let trackerReady = false
  let _bundle
  const eventQueue = []

  // This needs to be unique per contentId to avoid collisions when more than one
  // instance of forklaringsscroll is present in the document
  const contentContextId: `dh-${string}` = `${trackerId}-${selfId}`

  function trackEvent<T>(event: SelfDescribingJson<T>) {
    if (trackerReady === false) {
      eventQueue.push(event)
      return
    }

    const { NrknoUtils, Snowplow } = _bundle
    Snowplow.trackSelfDescribingEvent(
      {
        event,
        context: NrknoUtils.context.collect(['service', 'user', contentContextId]),
      },
      [trackerId],
    )
  }

  getBundle((bundle) => {
    _bundle = bundle
    const { NrknoUtils } = bundle
    NrknoUtils.newTracker(trackerId, APP_ID, host)

    if (process.env.DEV) {
      import('./snowplow-nrkno-mock.js').then(({ mock }) => mock(host)).catch(console.error)
    }

    if (selfId) {
      NrknoUtils.context.set(contentContextId, EntitySchema.Content as any, {
        source: 'pp',
        id: selfId,
      })
    }

    resolveOrTimeout(NrknoUtils.trackers.whenReady('main-tracker'), 1000)
      .then((isResolved) => {
        trackerReady = true
        if (isResolved === false) {
          console.warn('nrkno tracker not available')
        }

        // Clear the event queue
        for (let i = eventQueue.length - 1; i >= 0; i--) {
          const event = eventQueue.pop()
          trackEvent(event)
        }

        return
      })
      .catch(console.error)
  })

  return trackEvent
}
